import { ButtonIcon, ModalRush, ModalRushPage } from '@/ui'
import { useState } from 'react'
import { HUB_PATH, useGenerateCompanyPath, useNavigateBack } from '@/libs'
import { Collapse, XClose } from '@dashboard/ui'
import { TokenStudioTableWidget } from '../widgets'
import { useQuery } from '@tanstack/react-query'
import { websiteLastQueryOpts } from '@/layouts/websites'
import { themeQueryOpts } from '../api'
import { WebsiteRead } from '@/api/dashboard'

interface TokenStudioRushPageProps {
  onClose: () => void
}

export const TokenStudioRushPage = ({ onClose }: TokenStudioRushPageProps) => {
  const back = useNavigateBack({ fallback: HUB_PATH })
  const [collapsed, setCollapsed] = useState<boolean>(false)

  const { companyId, gameId } = useGenerateCompanyPath()
  const { data: website } = useQuery(websiteLastQueryOpts(companyId, gameId))

  const { isLoading: isLoadingTheme } = useQuery({
    ...themeQueryOpts(gameId, website as WebsiteRead),
    enabled: !!website,
  })

  const CollapseCloseButtons = () => {
    return (
      <div className="flex gap-2">
        <ButtonIcon
          onClick={() => {
            setCollapsed(!collapsed)
          }}
          type="button"
          size="sm"
          variant="outline"
          color="secondary"
          className="border-0"
        >
          <Collapse />
        </ButtonIcon>
        <ButtonIcon size="sm" variant="outline" color="secondary" onClick={onClose}>
          <XClose />
        </ButtonIcon>
      </div>
    )
  }

  if (isLoadingTheme) {
    return null
  }

  return (
    <ModalRushPage collapsed={collapsed} back={back}>
      {props => (
        <ModalRush {...props}>
          <div className="absolute right-4 z-30 bg-bg-secondary">
            <CollapseCloseButtons />
          </div>

          {collapsed ? (
            <div className="flex h-8 items-center">
              <div className="text-caption-lg">Token Studio</div>
            </div>
          ) : (
            <div className="relative h-full overflow-y-auto">
              {website && <TokenStudioTableWidget website={website} />}
            </div>
          )}
        </ModalRush>
      )}
    </ModalRushPage>
  )
}
